import { render, staticRenderFns } from "./MultipleChoiceOneAnswer.vue?vue&type=template&id=2af4995a&scoped=true&"
import script from "./MultipleChoiceOneAnswer.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceOneAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceOneAnswer.vue?vue&type=style&index=0&id=2af4995a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4995a",
  null
  
)

export default component.exports